/*
 * Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import { Component, OnInit, Input } from '@angular/core';

@Component({
    selector: 'gm-showcase',
    templateUrl: './showcase.component.html',
    styleUrls: ['./showcase.component.less'],
    standalone: false
})
export class ShowcaseComponent implements OnInit {
  @Input('showcase-title') title: string;
  @Input() showBackButton: boolean = false;
  @Input() blurBackground: boolean = false;

  constructor() { }

  ngOnInit() {
  }

}
